module.exports = __webpack_public_path__ + "img/bottom.9f061753.svg";